import {
    ContactAccessRightsConfig,
} from 'app/types/accessRights.types'

const contactAccessRights: ContactAccessRightsConfig = {
    location_sales: {
        CLIENT_SERVICES: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_airlines: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_cs: {
        CLIENT_SERVICES: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        BILLING: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_cs_super: {
        CLIENT_SERVICES: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        BILLING: {
            read: false,
            create: true,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_bil: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_ops: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: true,
            edit: true,
            delete: false,
        },
    },
    location_ops_super: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: true,
            edit: true,
            delete: true,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_prd: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_rnd: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_pmo_super: {
        CLIENT_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: false,
            create: false,
            edit: false,
            delete: false,
        },
    },
    location_read: {
        CLIENT_SERVICES: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        BILLING: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        OPERATIONS: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
        TECHNICAL_SERVICES: {
            read: true,
            create: false,
            edit: false,
            delete: false,
        },
    },
}

export default contactAccessRights
